export * from './format';
export * from './initialize';
export * from './checks';
export * from './buildOptions';
export * from './constants';
export * from './customDimension';
export * from './escape';
export * from './parse';
export * from './refetch';
export * from './common';
export * from './validates';
export * from './mappedEvents';
export * from './merge';

export const toLowerCase = (source?: any): string => {
  source = source ?? '';
  return `${source}`.toLowerCase();
};
